var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaflet-maps-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{staticClass:"leaflet-maps-page__widget",attrs:{"headerText":"Leaflet Maps"}},[_c('leaflet-map')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }